jQuery(window).ready(function() {

    // Enable google tag manger on click. For example on buttons
    jQuery('[data-ga-enable="1"]').click(function() {
        var event = jQuery(this).attr('data-ga-event');
        var gaEventCategory = jQuery(this).attr('data-ga-eventcategory');
        var gaEventAction = jQuery(this).attr('data-ga-eventaction');

        var gaEventLabel = jQuery(this).attr('data-ga-eventlabel');

        if (gaEventLabel === 'window.location.href') {
			gaEventLabel = window.location.href;
        }

        if (typeof gaEventLabel == typeof undefined || gaEventLabel == false) {
            gaEventLabel = jQuery(this).attr('href');

            if (typeof gaEventLabel == typeof undefined || gaEventLabel == false) {
                gaEventLabel = window.location.href;
            }
        }

		if (typeof jQuery(this).attr('data-ga-eventlabelprefix') !== typeof undefined && jQuery(this).attr('data-ga-eventlabelprefix').length > 0) {
			gaEventLabel = jQuery(this).attr('data-ga-eventlabelprefix') + gaEventLabel;
		}

        dataLayerPush(event, gaEventCategory, gaEventAction, gaEventLabel);
    });

    // Enable google tag manger on form submit.
    jQuery('[data-ga-form-enable="1"]').submit(function() {
        var event = jQuery(this).attr('data-ga-event');
        var gaEventCategory = jQuery(this).attr('data-ga-eventcategory');
        var gaEventAction = jQuery(this).attr('data-ga-eventaction');

        if (jQuery(this).find('[data-ga-eventlabelvalue]').length > 0) {
            var gaEventLabel = jQuery(this).find('[data-ga-eventlabelvalue]').val();
        } else {
            var gaEventLabel = window.location.href;
        }

        dataLayerPush(event, gaEventCategory, gaEventAction, gaEventLabel);
    });

    if (typeof bmGoogleTagManager !== 'undefined' && bmGoogleTagManager.pushOnLoad == 1) {
        dataLayerPush(bmGoogleTagManager.event, bmGoogleTagManager.gaEventCategory, bmGoogleTagManager.gaEventAction, bmGoogleTagManager.gaEventLabel);
    }
});

function dataLayerPush(event, gaEventCategory, gaEventAction, gaEventLabel) {
    // Enable next lines for testing
    // console.log("Event: " + event);
    // console.log("Category: " + gaEventCategory);
    // console.log("Action: " + gaEventAction);
    // console.log("Label: " + gaEventLabel);

    if(typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': event,
            'gaEventCategory': gaEventCategory,
            'gaEventAction': gaEventAction,
            'gaEventLabel': gaEventLabel
        });
    }
}

function dataLayerPushData(data) {
	// Enable next lines for testing
	// console.log(data);

	if(typeof dataLayer !== 'undefined') {
		dataLayer.push(data);
	}
}
